const BellIcon = ({ color }: { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <g clipPath="url(#clip0_168_732)">
      <path
        d="M6.34095 14.9838C6.34095 15.8219 7.01905 16.5 7.85714 16.5C8.69524 16.5 9.37333 15.8219 9.37333 14.9838H6.34095ZM13.099 11.7914V7.35714C13.099 4.88095 11.3848 2.80857 9.06857 2.26V1.71143C9.06857 1.04095 8.52762 0.5 7.85714 0.5C7.18667 0.5 6.64571 1.04095 6.64571 1.71143V2.26C4.32952 2.80857 2.61524 4.88095 2.61524 7.35714V11.7914L1 13.4067V14.2143H14.7143V13.4067L13.099 11.7914ZM10.9048 8.88857H8.61905V11.1743H7.09524V8.88857H4.80952V7.35714H7.09524V5.07143H8.61905V7.35714H10.9048V8.88857Z"
        fill={color ?? "#002035"}
      />
    </g>
    <defs>
      <clipPath id="clip0_168_732">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default BellIcon;
